import React, { useState } from 'react';
import { Field, reduxForm } from 'redux-form';
import EyeIcon from 'mdi-react/EyeIcon';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import validate from './validate';
import renderField from '../../../shared/components/form/RenderField';
import SmartButton from '../../../shared/components/SmartButton';

const LogInForm = ({ t, handleSubmit }) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleShowPassword = () => {
    setShowPassword((prevState) => !prevState);
  };

  return (
    <form className="form" onSubmit={handleSubmit}>
      <div className="form__form-group">
        <span className="form__form-group-label text-white">
          {t('general.your-user')}
        </span>
        <div className="form__form-group-field">
          <Field
            name="login"
            component={renderField}
            type="text"
            placeholder={t('general.placeholders.your-user')}
          />
        </div>
      </div>
      <div className="form__form-group pb-2">
        <span className="form__form-group-label text-white">
          {t('general.your-password')}
        </span>
        <div className="form__form-group-field">
          <Field
            className="login__form__input"
            name="password"
            component={renderField}
            type={showPassword ? 'text' : 'password'}
            placeholder={t('general.placeholders.your-password')}
          />
          <button
            className={`form__form-group-button${
              showPassword ? ' active' : ''
            }`}
            onClick={handleShowPassword}
            type="button"
          >
            <EyeIcon />
          </button>
        </div>
      </div>
      <SmartButton
        type="submit"
        color="success"
        className="flex-grow-1"
        label={t('general.enter')}
      />
    </form>
  );
};

LogInForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default reduxForm({
  form: 'log_in_form',
  validate,
  keepDirtyOnReinitialize: true,
  enableReinitialize: true,
})(
  connect((state) => ({
    loading: state.loading,
  }))(withTranslation('common')(LogInForm))
);
